// extracted by mini-css-extract-plugin
export const siteTitle = "SiteTitle-module--siteTitle--2RI3X";